<template>
  <v-container>
    <v-row
      v-if="value.items && value.items.length"
      align="center"
      class="service-differentiators-section"
    >
      <v-col cols="12" xl="7">
        <v-row>
          <v-col v-for="item in value.items" :key="item.id" cols="12" md="4">
            <ServiceDifferentiatorsItem :value="item" />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-if="value.title || value.paragraph"
        class="mt-8 mt-xl-0"
        cols="12"
        xl="4"
        offset-xl="1"
      >
        <TitleParagraphCard :value="value" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>

<style lang="scss">
@use '#root/styles/settings.scss' as settings;
@use 'sass:map';

// SEE: https://codepen.io/enbee81/pen/yLyrmyg
// SEE: https://bennettfeely.com/clippy/
.service-differentiators-section {
  --tan: 0.158384440324536; // 9deg

  // HACK: Hardcoded card widths for now
  --card-width: calc(100vw - 32px);
  @media #{map.get(settings.$display-breakpoints, 'md')} {
    --card-width: 273px;
  }
  @media #{map.get(settings.$display-breakpoints, 'lg')} {
    --card-width: 373px;
  }
  @media #{map.get(settings.$display-breakpoints, 'xl')} {
    --card-width: 324px;
  }
  @media #{map.get(settings.$display-breakpoints, 'xxl')} {
    --card-width: 441px;
  }
  & {
    --clip-offset: calc(var(--card-width) * var(--tan));
  }
}
</style>
